<template>
  <div class="banner_back">
    <section id="banner_back">
      <div class="inner_back">
        <p>{{title}}</p>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'banner-back',
    props: {
      title: {
        type: String,
        default: 'Vue!'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// BannerBack.vue?3c520fb8